<template>
	<div class="wrapper">
		<div class="top">
			<span>校园刷脸支付系统</span>
			<span>校园一脸通行 开启校园刷脸支付新时代</span>
		</div>
		<h3>校园支付新模式</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div>
			<video id="mPlayer" class="video-js vjs-big-play-centered" controls poster="//static.h5.ylmob.com/website/img/facepay-x.jpg?v=1" style="width: 6.25rem;height: 3.515625rem;"
			data-setup='{}'>
				<source src="https://outin-f6d3b6ae544411e9a52400163e1c8dba.oss-cn-shanghai.aliyuncs.com/sv/3248bca3-174be67ddbc/3248bca3-174be67ddbc.mp4" type="video/mp4" />
			</video>
		</div>

		<h3>平台优势</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="yoush_wrapper">
			<div class="youshi_c" style="margin-top: 0px;">
				<div class="youshi_i">
					<span></span>
					<span>大平台</span>
					<span>知会云校园与支付宝合作，支付安全有保障</span>
				</div>
				<div class="youshi_i">
					<span></span>
					<span>消费风控</span>
					<span>学生消费有限额，避免过度消费</span>
				</div>
			</div>
			<div class="youshi_c">
				<div class="youshi_i">
					<span></span>
					<span>高精准</span>
					<span>终端人脸识别速度毫秒级，误识率低于千万分之一</span>
				</div>
				<div class="youshi_i">
					<span></span>
					<span>数据安全</span>
					<span>人脸照片加密上传，保证学生信息安全性</span>
				</div>
			</div>
			<div class="youshi_c">
				<div class="youshi_i">
					<span></span>
					<span>可预付</span>
					<span>应对支付宝余额不足意外情况，保障孩子安心吃饭</span>
				</div>
				<div class="youshi_i">
					<span></span>
					<span>离线使用</span>
					<span>断网离线可用算法和人脸内置到设备上，设备离线照常使用</span>
				</div>
			</div>

			<div class="youshi_c">
				<div class="youshi_i">
					<span></span>
					<span>账单透明</span>
					<span>每笔消费记录实时发送给家长</span>
				</div>
				<div class="youshi_i">
					<span></span>
					<span>平台稳定</span>
					<span>软件与硬件基础设施支撑，平台自主研发，响应速度快</span>
				</div>
			</div>
		</div>

		<h3>落地效果</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="demo_wrapper">
			<div class="situation">
				<div class="situation_video">
					<video id="mPlayer1" class="video-js vjs-big-play-centered" controls poster="//static.h5.ylmob.com/website/img/0.jpg" style="width: 3.125rem;height: 1.760416rem;"
					data-setup='{}'>
						<source src="https://outin-f6d3b6ae544411e9a52400163e1c8dba.oss-cn-shanghai.aliyuncs.com/sv/587b9cb1-174c0169251/587b9cb1-174c0169251.mp4"
						type="video/mp4" />
					</video>
				</div>
				<div class="situation_remark">
					<div class="remark left">
						<span>食堂支付场景</span>
					</div>
				</div>
			</div>
			<div class="situation">
				<div class="situation_remark">
					<div class="remark right">
						<span>商超支付场景</span>
					</div>
				</div>
				<div class="situation_video">
					<video id="mPlayer2" class="video-js vjs-big-play-centered" controls poster="https://outin-f6d3b6ae544411e9a52400163e1c8dba.oss-cn-shanghai.aliyuncs.com/dbc389f5cbba4b6982557eddcf068855/snapshots/525e5b5e15ce4b4f8937ef876441d12e-00002.jpg" style="width: 3.125rem;height: 1.760416rem;"
					data-setup='{}'>
						<source src="https://outin-f6d3b6ae544411e9a52400163e1c8dba.oss-cn-shanghai.aliyuncs.com/sv/51be186f-174c017417d/51be186f-174c017417d.mp4"
						type="video/mp4" />
					</video>
				</div>
			</div>
		</div>

		<div class="dingwei">
			<h3 style="color:rgba(255,255,255,1);">成功案例</h3>
			<div class="short_stub">
				<div style="background:rgba(255,255,255,1);"></div>
				<div style="background:rgba(255,255,255,1);"></div>
			</div>
			<div class="dingwei_c">
				<div class="school_c">
					<div :class="index == showIndex?'school_i_p':'school_i_n'" v-for="(item, index) in schoolList" :key="index">
						<img src="//static.h5.ylmob.com/website/img/yinghao.png" />
						<span>{{item}}</span>
						<div v-if="index == showIndex" class="btn_check">
							<span>查看案例</span>
							<img src="//static.h5.ylmob.com/website/img/arrow_right.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.vjs-big-play-button {
		left: 50% !important;
		top: 50% !important;
		margin-left: -2em;
		margin-top: -1.3em;
	}

	.school_c {
		display: flex;
		align-items: center;
		display: -webkit-flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: wrap;
		margin-bottom: 0.3125rem;
	}

	.school_c:after {
		content: "";
		width: 1.942708rem;
	}

	.school_i_n {
		width: 1.942708rem;
		height: 1.041667rem;
		background: rgba(255, 255, 255, 1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 0.208333rem;
	}

	.school_i_n img {
		width: 0.208333rem;
		height: 0.192708rem;
		opacity: 0.5;
	}

	.school_i_n span {
		font-size: 0.104167rem;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		line-height: 0.104167rem;
	}

	.school_i_p {
		width: 1.942708rem;
		height: 1.145833rem;
		background: rgba(255, 255, 255, 1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 0.15625rem;
		box-shadow: 0px .15625rem .46875rem -.104167rem rgba(63, 110, 240, 0.2);
	}

	.school_i_p img {
		width: 0.208333rem;
		height: 0.192708rem;
	}

	.school_i_p span {
		font-size: 0.104167rem;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		line-height: 0.104167rem;
	}

	.dingwei {
		width: 100%;
		height: 2.578125rem;
		background: rgba(47, 110, 240, 1);
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 0.208333rem;
	}

	.dingwei_d {
		width: 3.125rem;
		font-size: .083333rem;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: .125rem;
		text-align: left;
	}

	.dingwei_c {
		display: flex;
		align-items: center;
		margin-top: 0.260417rem;
	}

	.dingwei_c_c {
		position: relative;
		width: 3.385417rem;
		height: 3.385417rem;
		background: rgba(255, 255, 255, 0.05);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 0.911458rem;
	}

	.dingwei_c_s {
		width: 2.5rem;
		height: 2.5rem;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 50%;
	}

	.dingwei_c_c img {
		position: absolute;
		width: 2.140625rem;
		height: 2.953125rem;
	}


	.demo_wrapper {}

	.situation {
		display: flex;
		flex-direction: row;
		width: 6.25rem;
	}

	.situation_video,
	.situation_remark {
		width: 3.125rem;
	}

	.situation_remark {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.remark {
		width: 2.083333rem;
		height: 0.520833rem;
		background: #3875F6;
	}

	.left::before {
		content: '';
		width: 0;
		height: 0;
		border: 0.15625rem solid transparent;
		border-bottom: 0.104166rem solid #3875F6;
		top: 0.052083rem;
		left: -0.416666rem;
		position: relative;
		pointer-events: none;
	}

	.right::after {
		content: '';
		width: 0;
		height: 0;
		border: 0.15625rem solid transparent;
		border-bottom: 0.104166rem solid #3875F6;
		top: 0.052083rem;
		right: -0.416666rem;
		position: relative;
		pointer-events: none;
	}

	.remark span {
		line-height: 0.520833rem;
		font-size: 0.208333rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		position: relative;
	}

	.left span {
		left: -0.15625rem;
	}

	.right span {
		right: -0.15625rem;
	}


	.yoush_wrapper {
		margin-top: 0.145833rem;
	}

	.youshi_c {
		display: flex;
		align-items: center;
		justify-content: center;
		/* flex-wrap: wrap; */
		margin-top: 0.208333rem;
		width: 6.25rem;
	}

	.youshi_i {
		display: flex;
		width: 50%;
		flex-direction: column;
		align-items: flex-start;
		margin-left: 0.572916rem;
	}

	.youshi_i span:nth-child(1) {
		position: relative;
		top: 0.052083rem;
		left: -0.052083rem;
		width: 0.104166rem;
		height: 0.104166rem;
		border-radius: 100%;
		background: rgba(47, 110, 240, .15);
	}

	.youshi_i span:nth-child(2) {
		font-size: 0.083333rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #3F6EF0;
		line-height: 0.083333rem;
	}

	.youshi_i span:nth-child(3) {
		margin-top: 0.052083rem;
		font-size: 0.083333rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #091630;
		line-height: 0.083333rem;
	}


	/* .fade-enter-active, .fade-leave-active {
  transition: all 1s ease;
}
.fade-enter, .fade-leave-to  {
  transform:translateY(-200px);
  opacity: 0;
} */

	.wrapper {
		width: 100%;
		display: -webkit-box;
		/* OLD - iOS 6-, Safari 3.1-6 */
		display: -moz-box;
		/* OLD - Firefox 19- (buggy but mostly works) */
		display: -ms-flexbox;
		/* TWEENER - IE 10 */
		display: -webkit-flex;
		/* NEW - Chrome */
		display: flex;
		/* NEW, Spec - Opera 12.1, Firefox 20+ */
		/* 09版 */
		-webkit-box-orient: vertical;
		/* 12版 */
		-webkit-flex-direction: column;
		-moz-flex-direction: column;
		-ms-flex-direction: column;
		-o-flex-direction: column;
		flex-direction: column;
		/* 09版 */
		-webkit-box-align: center;
		/* 12版 */
		-webkit-align-items: center;
		-moz-align-items: center;
		-ms-align-items: center;
		-o-align-items: center;
		align-items: center;
	}

	.top {
		width: 100%;
		height: 2.604167rem;
		background: url("//static.h5.ylmob.com/website/img/face2pay.png") no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.top span:nth-child(1) {
		font-size: 0.3125rem;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 0.3125rem;
		margin-left: 1.880208rem;
	}

	.top span:nth-child(2) {
		font-size: 0.15625rem;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.75);
		line-height: 0.15625rem;
		margin-top: 0.15625rem;
		margin-left: 1.880208rem;
	}

	.banner {
		width: 100%;
	}
</style>


<script>
	// @ is an alias to /src

	export default {
		name: "Face2Pay",
		components: {},
		data() {
			return {
				schoolList: [
					"来宾市第十一中学",
					"良江初级中学",
					"嵊州初级中学",
					"余姚市姚北实验学校",
					"杭州建德新世纪实验学校",
				],
				hoverIndex: 0,
				showIndex: -1
			};
		},

		methods: {
			showHover(index) {
				this.hoverIndex = index;
			},
		},
		mounted() {
			var options = {};
			var player = this.$video('mPlayer', options, function onPlayerReady() {
				this.on('play', function() {
					player1.pause();
					player2.pause();
				});
				
				this.on('ended', function() {
					console.log("=========================");
				});
			});
			
			var player1 = this.$video('mPlayer1', options, function onPlayerReady() {
				this.on('ended', function() {
					console.log("=========================");
				});
				this.on('play', function() {
					player.pause();
					player2.pause();
				});
			});
			
			var player2 = this.$video('mPlayer2', options, function onPlayerReady() {
				
				this.on('play', function() {
					player.pause();
					player1.pause();
				});
				this.on('ended', function() {
					console.log("=========================");
				});
			});
		}
	};
</script>
